import ApiService from '@/core/services/api.service';

export default {
  async validatePoints(customerId, pointsToUse) {
    const response = await ApiService.post('v1/customer-points/validate', {
      customerId,
      pointsToUse,
    });

    return response.data.data;
  },
};
